import React, { lazy, Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { convertToCamelCase } from "../utils/helpers";
import ErrorBoundary from "../components/ErrorBoundary/ErrorBoundary";
import Spinner from "../components/Spinner/Spinner";
import { fetchPagesSections } from "../actions/pages-actions";
import { pagesActions } from "../store/pages-slice";
import { useParams } from "react-router-dom";
import SingleBlogPostHeroSection from "../components/SingleBlogPostHeroSection/SingleBlogPostHeroSection";
import LatestBlogPosts from "../components/LatestBlogPosts/LatestBlogPosts";

const loadComponent = (name) => {
  try {
    return lazy(() => import(`../components/${name}/${name}.js`));
  } catch (error) {
    console.error(`Failed to load component ${name}`, error);
    return null;
  }
};

const SinglePost = ({ slug }) => {
  const loading = useSelector((state) => state.pages.loadingData);
  const { postSlug } = useParams();
  const dispatch = useDispatch();

  const apiSlug = "posts";

  const postData = useSelector(
    (state) => state.pages.sections[apiSlug + postSlug]
  );

  useEffect(() => {
    if (!postData) {
      dispatch(pagesActions.setLoadingData(true));
      dispatch(fetchPagesSections(apiSlug, postSlug));
    }
  }, [dispatch, apiSlug, postData]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div>
      <Suspense fallback={<Spinner />}>
        {postData && <SingleBlogPostHeroSection data={postData} />}
        {postData &&
          postData?.page_builder &&
          postData?.page_builder.map((section, index) => {
            const componentName = convertToCamelCase(section.acf_fc_layout);
            const Component = loadComponent(componentName);

            return (
              <ErrorBoundary key={index}>
                {Component ? (
                  <Component key={index} data={section} />
                ) : (
                  <div>Component not found: {componentName}</div>
                )}
              </ErrorBoundary>
            );
          })}
        {postData && (
          <LatestBlogPosts
            data={postData?.related_posts}
            heading="More from our blog"
          />
        )}
      </Suspense>
    </div>
  );
};

export default SinglePost;
